import React from 'react'
import { SessionBrief } from '../../types/SessionBrief'
import { differenceInMinutes, getSessionDateTimeSpan } from '../../utils/dateUtils'
import CountryFlag from '../CountryFlag/CountryFlag'
import SessionTags from '../SessionTags/SessionTags'
import ArrowIconMinimal from '../Icons/ArrowIconMinimal'
import { getSessionSummary } from '../../utils/sessionUtils'
import { IcaCheckbox } from '../IcaElements/IcaCheckbox'
import { useDeviceContext } from '../../contexts/device-context'
import { getCountryCode } from '../../utils/userUtils'

export interface ISessionListItem {
  session: SessionBrief,
  setSelectedCustomerId?: (customerId: string | null) => void,
  selectedCustomerId?: string | null,
  viewed: boolean
  pageType: string
}

export default function SessionListItem({ session, setSelectedCustomerId, selectedCustomerId, viewed, pageType } : ISessionListItem) {

  const { deviceState } = useDeviceContext()

  return (
    <div className='list-item__container'>
      <div className='list-item__left'>
        <div className='list-item__date flex items-center'>
          {session.isShopping 
            ? <><div className='list-item__is-shopping-icon mr-2'></div>Pågående kundvarv</>
            : <div>{getSessionDateTimeSpan(session.firstActivity, session.latestActivity, true)}</div>}
          <span className='ml-1'>({differenceInMinutes(session.firstActivity, session.latestActivity)} min)</span>
          {viewed && <span className='ml-2 font-bold text-[var(--color-green)]'>Granskad</span>}
        </div>
        <div className='my-1 list-item__session_items'>{getSessionSummary(session)}</div>
        <div className='flex flex-col lg:flex-row'>
          <div className='flex flex-wrap break-all items-center'>
            <div className='flex items-center gap-2 list-item__id mr-2'>
              { setSelectedCustomerId && 
                    <div className="tooltip tooltip--start">
                      {!deviceState.isMobile && <div className="tooltip-text">Markera för att se alla kundvarv med detta kund-id.</div>}
                      <IcaCheckbox 
                        checked={selectedCustomerId === session.customerId}
                        onClick={(e: React.MouseEvent) => e.stopPropagation()}
                        onChange={() => setSelectedCustomerId(selectedCustomerId === session.customerId ? null : session.customerId)}
                      />
                    </div>}
              <p>{pageType === 'session' ? `Kund-id: ${session.customerId}` : `${deviceState.isMobile ? '' : 'Kundvarvs-id:'} ${session.id}`}</p>
            </div>
            {(session.acr && !session.acr.includes('icase-bankid-qr bankid')) && <span className='mr-2'><CountryFlag countryCode={getCountryCode(session.countryCode, session.acr)}/></span>}
            {(!deviceState.isMobile && session.paymentInternalDisplayName) && <div className='list-item__payment_method mb-1 lg:mb-0'>{session.paymentInternalDisplayName}</div>}
          </div>
          {(deviceState.isMobile && session.paymentInternalDisplayName) && <div className='list-item__payment_method mt-1 lg:mb-0'>{session.paymentInternalDisplayName}</div>}
        </div>
      </div>
      <div className='list-item__right flex items-center'>
        <SessionTags containerClassName='flex flex-wrap md:justify-end'
          accessDeniedReason={session.accessDeniedReason}
          hasCustomerWeighedItems={session.hasCustomerWeighedItems}
          hasMultipleCompletedPayments={session.hasMultipleCompletedPayments}
          hasRemovedItems={session.hasRemovedItems}
          isMissingPayment={session.isMissingPayment}
          isSessionFlagged={session.isSessionFlagged}
          isCustomerFlagged={session.isCustomerFlagged}>
        </SessionTags>
      </div>
      <div className='list-item__arrow flex items-center'>
        <ArrowIconMinimal direction='right' size='32px'></ArrowIconMinimal>
      </div>
    </div>
  )
}
